var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourTabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.929 41.769H3.98828V43.3028H14.929V41.769Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.531 43.4048H14.9297V44.9386H19.531V43.4048Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1229 46.4722H6.95312V48.006H10.1229V46.4722Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53379 45.6543H0V47.1881H1.53379V45.6543Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6044 46.4722H21.0625V48.006H36.6044V46.4722Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5254 43.4048H32.0039V44.9386H37.5254V43.4048Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7769 41.769H37.5273V43.3028H39.7769V41.769Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8347 41.769H24.9492V43.3028H28.8347V41.769Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0013 44.1206H44.582V45.6544H50.0013V44.1206Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1282 47.2905H40.4922V48.8243H42.1282V47.2905Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0009 41.0532H47.5469V42.587H50.0009V41.0532Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53379 41.0532H0V42.587H1.53379V41.0532Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4143 25.4092H21.0625V26.943H23.4143V25.4092Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4705 35.5317H27.3008V37.0655H30.4705V35.5317Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7001 18.4561V19.8875H20.2461V21.4213H22.7001V19.9897H25.6653V18.4561H22.7001Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8347 28.5786H24.9492V30.1124H28.8347V28.5786Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4046 37.8832L43.0378 33.6437C44.7289 33.1852 46.2663 32.2573 47.4728 30.9441C49.0614 29.215 49.9363 26.9686 49.9363 24.6188C49.9363 19.4622 45.7411 15.267 40.5845 15.267C38.665 15.267 36.8204 15.8443 35.2501 16.9366C34.0311 17.7845 33.0438 18.8943 32.3495 20.1844L24.9754 10.8984L3.54639 37.8832H0V39.417H50V37.8832H46.4046ZM40.5846 16.8008C44.8955 16.8008 48.4026 20.3079 48.4026 24.6188C48.4026 26.5833 47.6714 28.461 46.3434 29.9065C45.1805 31.1723 43.6507 32.0109 41.9804 32.3121L33.4065 21.5155C34.6464 18.642 37.4335 16.8008 40.5846 16.8008ZM24.7638 13.6315L25.445 15.2861H23.4497L24.7638 13.6315ZM5.50498 37.8832L6.17383 37.041L16.36 37.0652V35.5314H7.37246L7.94082 34.8157H10.8384V33.282H9.15889L15.4111 25.4088H21.0634V23.875H16.6291L22.2317 16.8198H26.0766L32.1814 31.646H30.4703V33.1798H32.813L34.7497 37.8833H5.50498V37.8832ZM36.4085 37.8832L35.1454 34.8157H37.5256V33.282H34.514L27.7527 16.862L35.7579 26.9426H34.3559V28.4764H36.9759L37.6255 29.2943H35.8896V30.8281H38.8435L44.4461 37.8833H36.4085V37.8832Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70244 1.99365H3.06641V3.52744H4.70244V1.99365Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1236 6.69727H8.58984V8.23105H10.1236V6.69727Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87432 12.9346H6.23828V14.4684H7.87432V12.9346Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06895 22.3413H1.53516V23.8751H3.06895V22.3413Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1236 26.2271H8.58984V27.7608H10.1236V26.2271Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2916 16.8198H11.7578V18.3536H13.2916V16.8198Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6041 8.23096H35.0703V9.76475H36.6041V8.23096Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8307 12.1167H45.2969V13.6505H46.8307V12.1167Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4134 5.87939H21.7773V7.41318H23.4134V5.87939Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.472 1.17578H28.8359V2.70957H30.472V1.17578Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9439 2.81201H41.4102V4.3458H42.9439V2.81201Z",
    fill: "#C10707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9986 32.4644H48.4648V33.9981H49.9986V32.4644Z",
    fill: "#C10707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourTabIcon);
export default __webpack_public_path__ + "static/media/tourTabIcon.1f8c891147f608e9a23f8abc5b5232b6.svg";
export { ForwardRef as ReactComponent };